
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('notifyMeForm');
    const modal = document.getElementById('notifyModal');
    const statusEl = document.getElementById('notifyStatus');
    const emailInput = form.querySelector("input[name='email']");
    const emailError = document.getElementById('emailError');
    const emailSuggestion = document.getElementById('emailSuggestion');
    const submitBtn = form.querySelector('.notify-me-submit');

    // Common email domain typos
    const domainCorrections = {
      'gmial.com': 'gmail.com',
      'gmai.com': 'gmail.com',
      'gmil.com': 'gmail.com',
      'gmaill.com': 'gmail.com',
      'yahooo.com': 'yahoo.com',
      'yaho.com': 'yahoo.com',
      'hotmial.com': 'hotmail.com',
      'hotmai.com': 'hotmail.com',
      'outlok.com': 'outlook.com',
      'outloo.com': 'outlook.com',
      'iclould.com': 'icloud.com',
      'icoud.com': 'icloud.com',
      'aol.co': 'aol.com',
      'gmx.co': 'gmx.com',
    };

    // ----------------------
    // Advanced Email validation
    // ----------------------
    function validateEmail() {
      const email = emailInput.value.trim();
      emailSuggestion.textContent = '';

      // Check if empty
      if (emailInput.validity.valueMissing || !email) {
        emailInput.setCustomValidity('Email is required.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Email is required.';
        return false;
      }

      // Basic format check with more strict regex
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        emailInput.setCustomValidity('Enter a valid email address.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Enter a valid email address.';
        return false;
      }

      // Extract domain
      const parts = email.split('@');
      if (parts.length !== 2) {
        emailInput.setCustomValidity('Invalid email format.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Invalid email format.';
        return false;
      }

      const [localPart, domain] = parts;

      // Check for common issues
      if (localPart.length === 0) {
        emailInput.setCustomValidity('Email username cannot be empty.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Email username cannot be empty.';
        return false;
      }

      if (domain.indexOf('.') === -1) {
        emailInput.setCustomValidity('Domain must contain a dot (e.g., .com).');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Domain must contain a dot (e.g., .com).';
        return false;
      }

      // Check for consecutive dots
      if (email.includes('..')) {
        emailInput.setCustomValidity('Email cannot contain consecutive dots.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Email cannot contain consecutive dots.';
        return false;
      }

      // Check for spaces
      if (email.includes(' ')) {
        emailInput.setCustomValidity('Email cannot contain spaces.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Email cannot contain spaces.';
        return false;
      }

      // Check domain length
      const domainParts = domain.split('.');
      const tld = domainParts[domainParts.length - 1];
      if (tld.length < 2) {
        emailInput.setCustomValidity('Invalid domain extension.');
        emailInput.classList.add('invalid');
        emailError.textContent = 'Invalid domain extension.';
        return false;
      }

      // Check for common typos in domain
      const lowerDomain = domain.toLowerCase();
      if (domainCorrections[lowerDomain]) {
        const suggestedEmail = localPart + '@' + domainCorrections[lowerDomain];
        emailSuggestion.textContent = `Did you mean ${suggestedEmail}?`;
        emailSuggestion.onclick = () => {
          emailInput.value = suggestedEmail;
          validateEmail();
        };
        emailInput.classList.add('invalid');
        emailError.textContent = 'Please check the domain spelling.';
        return false;
      }

      // All checks passed
      emailInput.setCustomValidity('');
      emailInput.classList.remove('invalid');
      emailError.textContent = '';
      return true;
    }

    // Real-time validation
    emailInput.addEventListener('input', () => {
      if (emailInput.value.trim()) {
        validateEmail();
      } else {
        emailInput.classList.remove('invalid');
        emailError.textContent = '';
        emailSuggestion.textContent = '';
      }
    });

    emailInput.addEventListener('blur', validateEmail);

    // ----------------------
    // Get variant data from product JSON
    // ----------------------
    function getVariantDataFromPage(variantId) {
      try {
        // Try to get from product JSON script tag
        const productJson = document.querySelector('script[type="application/json"][data-product-json]');
        if (productJson) {
          const product = JSON.parse(productJson.textContent);
          const variant = product.variants.find((v) => v.id == variantId);
          return variant;
        }

        // Try alternate selector
        const productData = document.querySelector('.product-json, [data-product-json]');
        if (productData) {
          const product = JSON.parse(productData.textContent);
          const variant = product.variants.find((v) => v.id == variantId);
          return variant;
        }

        // Try from window object (some themes store it there)
        if (window.ShopifyProduct && window.ShopifyProduct.variants) {
          return window.ShopifyProduct.variants.find((v) => v.id == variantId);
        }

        // Try to find variant from media gallery or other sources
        const variantMediaElement = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (variantMediaElement && variantMediaElement.dataset.variantImage) {
          return { featured_image: { src: variantMediaElement.dataset.variantImage } };
        }
      } catch (error) {
        console.error('Error parsing variant data:', error);
      }
      return null;
    }

    // ----------------------
    // Update form from swatch (selected variant radio)
    // ----------------------
    function updateFormFromSwatch() {
      // Find the currently checked radio button
      const activeInput = document.querySelector('variant-selects input[type="radio"]:checked');

      if (!activeInput) return false;

      const variantId = activeInput.dataset.variantId || activeInput.value;

      form.dataset.variantId = variantId;
      form.dataset.productId = activeInput.dataset.productId;
      form.dataset.variantTitle = activeInput.dataset.variantTitle;
      form.dataset.productTitle = activeInput.dataset.productTitle || '';

      // Try to get variant image from radio button data
      let variantImage = activeInput.dataset.variantImage;

      // Fallback: Try to fetch variant image from Shopify if not in data attribute
      if (!variantImage && variantId) {
        const variantData = getVariantDataFromPage(variantId);
        if (variantData && variantData.featured_image) {
          variantImage = variantData.featured_image.src;
        }
      }

      form.dataset.variantImage = variantImage || form.dataset.productImage;

      // Update modal content
      updateModalContent({
        dataset: {
          variantTitle: form.dataset.variantTitle,
          productTitle: form.dataset.productTitle,
          variantImage: form.dataset.variantImage,
          productImage: form.dataset.productImage,
        },
      });

      console.log('🎨 Using selected variant radio:', {
        variantId: form.dataset.variantId,
        productId: form.dataset.productId,
        variantTitle: form.dataset.variantTitle,
        variantImage: form.dataset.variantImage,
      });

      return true;
    }

    // ----------------------
    // Get data from hidden variant input (fallback)
    // ----------------------
    function updateFormFromHiddenInput() {
      const variantInput = document.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) return false;

      form.dataset.variantId = variantInput.value;

      // Try to get product ID from the form or page
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm && productForm.dataset.productId) {
        form.dataset.productId = productForm.dataset.productId;
      }

      console.log('📌 Using hidden input fallback:', {
        variantId: form.dataset.variantId,
        productId: form.dataset.productId,
      });

      return true;
    }

    // ----------------------
    // Update form from button
    // ----------------------
    function updateFormFromButton(button) {
      let hasData = false;

      if (button.dataset.variantId) {
        form.dataset.variantId = button.dataset.variantId;
        hasData = true;
      }
      if (button.dataset.productId) {
        form.dataset.productId = button.dataset.productId;
        hasData = true;
      }
      if (button.dataset.variantTitle) {
        form.dataset.variantTitle = button.dataset.variantTitle;
        hasData = true;
      }
      if (button.dataset.productTitle) {
        form.dataset.productTitle = button.dataset.productTitle;
        hasData = true;
      }
      if (button.dataset.variantImage) {
        form.dataset.variantImage = button.dataset.variantImage;
        hasData = true;
      }
      if (button.dataset.productImage) {
        form.dataset.productImage = button.dataset.productImage;
        hasData = true;
      }

      // Update modal content
      if (hasData) {
        updateModalContent(button);
        console.log('🔘 Using button data:', {
          variantId: form.dataset.variantId,
          productId: form.dataset.productId,
          variantTitle: form.dataset.variantTitle,
          variantImage: form.dataset.variantImage,
        });
      }

      return hasData;
    }

    // ----------------------
    // Update modal content (image and title)
    // ----------------------
    function updateModalContent(element) {
      const modalTitle = document.getElementById('modalProductTitle');
      const modalImage = document.getElementById('modalProductImage');

      // Update title
      if (element.dataset.variantTitle && modalTitle) {
        const productTitle = element.dataset.productTitle || '';
        const variantTitle = element.dataset.variantTitle;
        modalTitle.textContent = productTitle
          ? variantTitle && variantTitle !== 'Default Title'
            ? `${productTitle} (${variantTitle})`
            : productTitle
          : variantTitle;
      }

      // Update image with multiple fallback attempts
      if (modalImage) {
        let imageUrl = null;

        // Priority 1: Variant-specific image
        if (
          element.dataset.variantImage &&
          element.dataset.variantImage !== 'null' &&
          element.dataset.variantImage !== ''
        ) {
          imageUrl = element.dataset.variantImage;
        }

        // Priority 2: Product image
        if (
          !imageUrl &&
          element.dataset.productImage &&
          element.dataset.productImage !== 'null' &&
          element.dataset.productImage !== ''
        ) {
          imageUrl = element.dataset.productImage;
        }

        // Priority 3: Check if variant has featured image from form data
        if (
          !imageUrl &&
          form.dataset.variantImage &&
          form.dataset.variantImage !== 'null' &&
          form.dataset.variantImage !== ''
        ) {
          imageUrl = form.dataset.variantImage;
        }

        // Priority 4: Use product image from form data
        if (
          !imageUrl &&
          form.dataset.productImage &&
          form.dataset.productImage !== 'null' &&
          form.dataset.productImage !== ''
        ) {
          imageUrl = form.dataset.productImage;
        }

        // Priority 5: Try to get from current variant in product JSON
        if (!imageUrl && form.dataset.variantId) {
          const variantData = getVariantDataFromPage(form.dataset.variantId);
          if (variantData && variantData.featured_image) {
            imageUrl = variantData.featured_image.src;
          }
        }

        // Update if we found a valid image
        if (imageUrl) {
          modalImage.src = imageUrl;
          modalImage.alt = element.dataset.variantTitle || element.dataset.productTitle || '';
          console.log('🖼️ Updated modal image to:', imageUrl);
        } else {
          console.warn('⚠️ No valid image found for variant');
        }
      }
    }

    // Swatch listeners - Listen for variant changes
    document.querySelectorAll('variant-selects input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', (e) => {
        console.log('✅ Variant changed:', e.target.dataset.variantId || e.target.value);

        // Give the page time to update variant data in DOM
        setTimeout(() => {
          updateFormFromSwatch();

          // Also update the modal if it's currently open
          if (!modal.classList.contains('hidden-model')) {
            updateModalContent({
              dataset: {
                variantTitle: form.dataset.variantTitle,
                productTitle: form.dataset.productTitle,
                variantImage: form.dataset.variantImage,
                productImage: form.dataset.productImage,
              },
            });
          }
        }, 100);
      });
    });

    // Notify button listeners - Use three-tier approach
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#notifyBtn');
      if (!btn) return; // not our button
      event.preventDefault();
      event.stopPropagation();

      // APPROACH 1: Try to get data from the button itself
      const hasButtonData = updateFormFromButton(btn);

      // APPROACH 2: If button doesn't have data, try selected radio button
      if (!hasButtonData) {
        const hasSwatchData = updateFormFromSwatch();

        // APPROACH 3: If no radio button selected, try hidden variant input
        if (!hasSwatchData) {
          updateFormFromHiddenInput();
        }
      }

      emailError.textContent = '';
      emailSuggestion.textContent = '';
      statusEl.textContent = '';
      modal.classList.remove('hidden-model');
    });

    // ----------------------
    // Form submission
    // ----------------------
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const isValid = validateEmail();
      if (!isValid) return;

      const email = emailInput.value.trim();
      const { variantId, productId, variantTitle, productTitle } = form.dataset;

      if (!variantId) {
        statusEl.classList.add('active');
        statusEl.textContent = 'Please select a variant first.';
        statusEl.style.color = 'red';
        return;
      }

      // Disable button and show loading state
      submitBtn.disabled = true;
      statusEl.classList.add('active');
      submitBtn.textContent = 'Subscribing...';
      statusEl.textContent = 'Submitting...';
      statusEl.style.color = 'black';

      try {
        const displayTitle =
          variantTitle && variantTitle !== 'Default Title' ? `${productTitle} - ${variantTitle}` : productTitle;

        const body = new FormData();
        body.append('email', email);
        body.append('variantId', variantId);
        body.append('productId', productId);
        body.append('productTitle', displayTitle);

        const res = await fetch('/apps/api/notify-me', { method: 'POST', body });
        const data = await res.json();

        if (data.ok) {
          statusEl.classList.add('active');
          statusEl.textContent =
            data.message === 'Already subscribed'
              ? "You're already subscribed for this variant."
              : "Subscribed successfully! We'll notify you when it's back in stock.";
          statusEl.style.color = data.message === 'Already subscribed' ? 'orange' : 'green';
          form.reset();
          emailInput.classList.remove('invalid');
          emailError.textContent = '';
          emailSuggestion.textContent = '';
        } else {
          statusEl.classList.add('active');
          statusEl.textContent = data.message || 'Something went wrong.';
          statusEl.style.color = 'red';
        }
      } catch (err) {
        statusEl.classList.add('active');
        console.error(err);
        statusEl.textContent = 'Error submitting subscription. Please try again.';
        statusEl.style.color = 'red';
      } finally {
        // Re-enable button
        submitBtn.disabled = false;
        submitBtn.textContent = 'Subscribe';
      }
    });

    // ----------------------
    // Modal close
    // ----------------------
    const closeModalBtn = document.getElementById('closeModal');

    function closeModal() {
      modal.classList.add('hidden-model');
      emailError.textContent = '';
      emailSuggestion.textContent = '';
      statusEl.textContent = '';
      statusEl.classList.remove('active');
      emailInput.classList.remove('invalid');
      emailInput.value = '';
    }

    if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.classList.contains('hidden-model')) {
        closeModal();
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('modal-backdrop')) {
        closeModal();
      }
    });
  });

